import popupModel from '@/model/popup';
import errorModel from '@/model/error';

/**
 * Выполняет запрос к api и показывает алерт, если он не прошёл.
 *
 * Нужен потому, что штатный разбор ошибок (см. model/error.js) выводит только
 * 403 и 404 на уровне страницы: без этой обёртки неудачная правка осталась бы
 * вообще без реакции — и упала бы необработанным reject'ом в обработчике клика.
 *
 * pageLevel решает, что делать с уже записанной в store ошибкой. По умолчанию
 * (false) она гасится: раз алерт показан, ошибка обработана здесь, и подменять
 * из-за неё всю страницу на ErrorPage не нужно — иначе отказ по правам на одном
 * действии (в CRM 403 это штатный ответ) выносил бы работающий экран целиком, а
 * вернуться на него можно было бы только сменив роут. pageLevel: true оставляют
 * первичным загрузкам экрана: там показать ErrorPage — как раз правильное
 * поведение.
 *
 * Возвращает null при неудаче. Успешный ответ null не приходит ни от одной
 * операции (см. api/rest/base/operations.js: DELETE отдаёт пустую строку),
 * поэтому вызывающие отличают отказ по `=== null`.
 */
// eslint-disable-next-line import/prefer-default-export
export async function apiRun(action, errorText, { pageLevel = false } = {}) {
  try {
    return await action();
  } catch (e) {
    // OperationRunner отклоняет промис и тут же кладёт ошибку в store, так что
    // к этому моменту она там уже есть — гасим до алерта, чтобы ErrorPage не
    // успел мигнуть за ним
    if (!pageLevel) errorModel.clear();

    const description = e?.description ?? e?.detail ?? e?.['hydra:description'] ?? ''; // eslint-disable-line
    await popupModel.addAlert(errorText, description);
    return null;
  }
}
